import React from "react";
import { Card, CardContent, Typography, IconButton, Grid } from "@mui/material";
import ViewIcon from "../../assets/Icon/ViewIcon.png";
import DownloadIcon from "../../assets/Icon/DownLoadIcon.png";
import DeletIcon1 from "../../assets/Icon/DeleteIcon.png";
import { styled } from "@mui/system";

// Styled components
const StyledCard = styled(Card)({
  height: "50px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#E7E7E7",
  border: "1px solid #A5A5A5",
  marginTop: "20px",
});

const StyledCardContent = styled(CardContent)({
  // display: "flex",
  justifyContent: "space-between",
  // alignItems: "center", // Align items vertically
  width: "100%",
  padding: "20px",
});

const StyledTypography = styled(Typography)({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "18px",
});

const StyledIconButton = styled(IconButton)({
  display: "flex",
  alignItems: "center",
  marginTop: "18px",
});

const SingleCustomCard = ({ data, showIcons, onView, onUpload, onDelete }) => {
  return (
    <Grid container>
      <Grid item xs={showIcons ? 6 : 12}>
        <StyledCard>
          <StyledCardContent>
            {Array.isArray(data) &&
              data.map((pair, index) => (
                <Grid key={index} container>
                  {!showIcons ? (
                    <>
                      <Grid item xs={6}>
                        <strong>{pair.label}:</strong>
                      </Grid>
                      <Grid item xs={6}>
                        <StyledTypography variant="body2">
                          {pair.value}
                        </StyledTypography>
                      </Grid>
                    </>
                  ) : (
                    <Grid item xs={6}>
                      <StyledTypography variant="body2">
                        {pair.value}
                      </StyledTypography>
                    </Grid>
                  )}
                </Grid>
              ))}
            {/* Render icons only if showIcons prop is true */}
          </StyledCardContent>
        </StyledCard>
      </Grid>
      {showIcons && (
        <>
          <Grid itme xs={2}>
            <StyledIconButton onClick={onView}>
              <img src={ViewIcon} alt="View" />
            </StyledIconButton>
          </Grid>
          <Grid item xs={2}>
            <StyledIconButton onClick={onUpload}>
              <img src={DownloadIcon} alt="Upload" />
            </StyledIconButton>
          </Grid>
          <Grid item xs={2}>
            <StyledIconButton onClick={onDelete}>
              <img src={DeletIcon1} />
            </StyledIconButton>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SingleCustomCard;
